module.exports = __webpack_public_path__ + "img/icon1.2b688b82.png";